import React from "react";
import PropTypes from "prop-types";

const AmcgPremiumMessage = ({ premiumSources, varsomePremiumUrl }) => {
  return !__IS_COMPONENTS_PORTAL__ && premiumSources ? (
    <div className="tw-flex tw-pt-2 tw-pb-1 tw-justify-center">
      <small className="varsome-text-muted">
        <i className="fa fa-exclamation-triangle" /> Users of{" "}
        <a href={varsomePremiumUrl} target="_blank">
          {" "}
          VarSome Premium{" "}
        </a>{" "}
        benefit from additional data sources included in the automated
        classification.
      </small>
    </div>
  ) : null;
};

AmcgPremiumMessage.propTypes = {
  premiumSources: PropTypes.shape({}),
  varsomePremiumUrl: PropTypes.string.isRequired,
};

AmcgPremiumMessage.defaultProps = {
  premiumSources: null,
};

export default React.memo(AmcgPremiumMessage);
